function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, ReactElement, useContext, useRef } from 'react';
import cn from 'classnames';
import { TableContext } from '../Table';
require("./TableCell.css");
var styles = {
  "Root": "TableCell-module-Root_21E",
  "stickyLeft": "TableCell-module-stickyLeft_236",
  "stickyRight": "TableCell-module-stickyRight_3He",
  "Content": "TableCell-module-Content_2Kv",
  "Resizer": "TableCell-module-Resizer_USc",
  "sSizes": "TableCell-module-sSizes_3oV",
  "mSizes": "TableCell-module-mSizes_1Y1",
  "lSizes": "TableCell-module-lSizes_1bR"
};
export const TableCellTags = {
  td: 'td',
  th: 'th'
};
export const TableCellSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const TableCell = ({
  children,
  tag = TableCellTags.td,
  verticalPgSizes = TableCellSizes.m,
  className,
  ...props
}) => {
  const rootRef = useRef(null);
  const {
    resizable,
    stickyLeftCols = [],
    stickyRightCols = []
  } = useContext(TableContext);
  const RootTag = tag;
  return /*#__PURE__*/React.createElement(RootTag, _extends({}, props, {
    ref: rootRef,
    className: cn(styles.Root, styles[`${verticalPgSizes}Sizes`], {
      [styles.stickyLeft]: stickyLeftCols.includes(Number(rootRef?.current?.cellIndex))
    }, {
      [styles.stickyRight]: stickyRightCols.includes(Number(rootRef?.current?.cellIndex))
    }, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.Content
  }, children), resizable && /*#__PURE__*/React.createElement("div", {
    className: styles.Resizer,
    "data-role": "resizer"
  }));
};